import React, { FC } from 'react';

import { formatTime } from '@/scenarios/legacy-player/components/PlayerSkin/hooks/useFormattedTime';
import { Preview } from '@/scenarios/legacy-player/components/PlayerSkin/parts/TimelineMarks/hooks/usePreview';

import { Time } from '../timeline/types/time';

import styles from './styles.module.css';

interface Props {
    preview?: Preview;
    time: Time;
}

export const TimelinePreview: FC<Props> = ({ preview, time }) => (
    <div className={styles.root}>
        {preview && <div className={styles.preview} style={preview} />}
        <span className={styles.time}>{formatTime(Math.floor(time.visibleTime), 60)[0]}</span>
    </div>
);
